import { REQUEST_DELETE_USER, REQUEST_DELETE_USER_SUCCESS, REQUEST_DELETE_USER_FAILED, REQUEST_EMAIL_VERIFICATION, REQUEST_EMAIL_VERIFICATION_SUCCESS, REQUEST_EMAIL_VERIFICATION_FAILED } from './Constant';

export const deleteUserRequest = (payload) => ({
    type: REQUEST_DELETE_USER,
    payload : payload
});
export const deleteUserRequestSuccess = (payload) => ({
    type: REQUEST_DELETE_USER_SUCCESS,
    payload: payload
});
export const deleteUserRequestError = () => ({
    type: REQUEST_DELETE_USER_FAILED,
});

export const emailVerificationRequest = (payload) => ({
    type: REQUEST_EMAIL_VERIFICATION,
    payload : payload
});
export const emailVerificationRequestSuccess = (payload) => ({
    type: REQUEST_EMAIL_VERIFICATION_SUCCESS,
    payload: payload
});
export const emailVerificationRequestError = () => ({
    type: REQUEST_EMAIL_VERIFICATION_FAILED,
});